import {
  FETCH_SCHEDULE_START,
  FETCH_SCHEDULE_SUCCESS,
  FETCH_SCHEDULE_ERROR,
  FETCH_APPOINTMENTS_START,
  FETCH_APPOINTMENTS_SUCCESS,
  FETCH_APPOINTMENTS_ERROR,
  FETCH_STUDENT_APPOINTMENTS_START,
  FETCH_STUDENT_APPOINTMENTS_SUCCESS,
  FETCH_STUDENT_APPOINTMENTS_ERROR,
  MAKE_APPOINTMENT_START,
  MAKE_APPOINTMENT_SUCCESS,
  MAKE_APPOINTMENT_ERROR,
  MAKE_APPOINTMENT_RESET,
  CANCEL_APPOINTMENT_START,
  CANCEL_APPOINTMENT_SUCCESS,
  CANCEL_APPOINTMENT_ERROR,
  CANCEL_APPOINTMENT_RESET,
  UPDATE_APPOINTMENT_START,
  UPDATE_APPOINTMENT_SUCCESS,
  UPDATE_APPOINTMENT_ERROR,
  UPDATE_APPOINTMENT_RESET,
  EXPRESS_INTEREST_START,
  EXPRESS_INTEREST_SUCCESS,
  EXPRESS_INTEREST_ERROR,
  EXPRESS_INTEREST_RESET,
  UNEXPRESS_INTEREST_START,
  UNEXPRESS_INTEREST_SUCCESS,
  UNEXPRESS_INTEREST_ERROR,
  UNEXPRESS_INTEREST_RESET,
  FETCH_EXPRESSED_INTERESTS_START,
  FETCH_EXPRESSED_INTERESTS_SUCCESS,
  FETCH_EXPRESSED_INTERESTS_ERROR,
  FETCH_EXPRESSED_INTERESTS_INSTRUMENTS_START,
  FETCH_EXPRESSED_INTERESTS_INSTRUMENTS_SUCCESS,
  FETCH_EXPRESSED_INTERESTS_INSTRUMENTS_ERROR,
  FETCH_SHARED_SCHEDULE_START,
  FETCH_SHARED_SCHEDULE_SUCCESS,
  FETCH_SHARED_SCHEDULE_ERROR,
  FETCH_SHARED_SCHEDULE_GT_FILTERED_START,
  FETCH_SHARED_SCHEDULE_GT_FILTERED_SUCCESS,
  FETCH_SHARED_SCHEDULE_GT_FILTERED_ERROR,
  FETCH_SHARED_SCHEDULE_GT_FILTERED_LOCATIONS_START,
  FETCH_SHARED_SCHEDULE_GT_FILTERED_LOCATIONS_SUCCESS,
  FETCH_SHARED_SCHEDULE_GT_FILTERED_LOCATIONS_ERROR,
  SCHEDULE_COMPLETE_START,
  SCHEDULE_COMPLETE_SUCCESS,
  SCHEDULE_COMPLETE_ERROR,
  NO_MATCHING_TIMESLOT_START,
  NO_MATCHING_TIMESLOT_SUCCESS,
  NO_MATCHING_TIMESLOT_ERROR,
  NO_MATCHING_TIMESLOT_RESET,
  FETCH_NO_MATCHING_TIMESLOTS_START,
  FETCH_NO_MATCHING_TIMESLOTS_SUCCESS,
  FETCH_NO_MATCHING_TIMESLOTS_ERROR,
  REMOVE_NO_MATCHING_TIMESLOT_START,
  REMOVE_NO_MATCHING_TIMESLOT_SUCCESS,
  REMOVE_NO_MATCHING_TIMESLOT_ERROR,
  REMOVE_NO_MATCHING_TIMESLOT_RESET,
} from '../constants';

const initialState = {
  loading: false,
  loaded: false,
  gtFilteredLoading: false,
  gtFilteredLoaded: false,
  error: null,
  result: [],
  gtFilteredLocationsLoading: false,
  gtFilteredLocationsLoaded: false,
  locations: [],
};

const sharedSchedules = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SHARED_SCHEDULE_START: {
      return {
        ...state,
        loading: true,
      };
    }

    case FETCH_SHARED_SCHEDULE_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        result: action.payload.results,
        error: null,
      };
    }

    case FETCH_SHARED_SCHEDULE_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    }
    case FETCH_SHARED_SCHEDULE_GT_FILTERED_START: {
      return {
        ...state,
        gtFilteredLoading: true,
        gtFilteredLoaded: false,
      };
    }

    case FETCH_SHARED_SCHEDULE_GT_FILTERED_SUCCESS: {
      return {
        ...state,
        gtFilteredLoading: false,
        gtFilteredLoaded: true,
        result: action.payload.results,
        error: null,
      };
    }

    case FETCH_SHARED_SCHEDULE_GT_FILTERED_ERROR: {
      return {
        ...state,
        gtFilteredLoading: false,
        error: action.payload,
      };
    }

    case FETCH_SHARED_SCHEDULE_GT_FILTERED_LOCATIONS_START: {
      return {
        ...state,
        gtFilteredLocationsLoading: true,
        gtFilteredLocationsLoaded: false,
      };
    }

    case FETCH_SHARED_SCHEDULE_GT_FILTERED_LOCATIONS_SUCCESS: {
      return {
        ...state,
        gtFilteredLocationsLoading: false,
        gtFilteredLocationsLoaded: true,
        locations: action.payload,
        error: null,
      };
    }

    case FETCH_SHARED_SCHEDULE_GT_FILTERED_LOCATIONS_ERROR: {
      return {
        ...state,
        gtFilteredLocationsLoading: false,
        error: action.payload,
      };
    }

    default:
      return state;
  }
};

const schedulePrograms = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SCHEDULE_START: {
      return {
        ...state,
        loading: true,
      };
    }

    case FETCH_SCHEDULE_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        result: action.payload,
        error: null,
      };
    }

    case FETCH_SCHEDULE_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    }
    default:
      return state;
  }
};

const appointments = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_APPOINTMENTS_START: {
      return {
        ...state,
        loading: true,
      };
    }

    case FETCH_APPOINTMENTS_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        result: action.payload.results,
        error: null,
      };
    }

    case FETCH_APPOINTMENTS_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    }

    case CANCEL_APPOINTMENT_SUCCESS: {
      return {
        ...state,
        result: state.result.filter(appointment => appointment.id !== action.payload.id),
      };
    }

    default:
      return state;
  }
};

const studentAppointments = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_STUDENT_APPOINTMENTS_START: {
      return {
        ...state,
        loading: true,
      };
    }

    case FETCH_STUDENT_APPOINTMENTS_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        result: action.payload.results,
        error: null,
      };
    }

    case FETCH_STUDENT_APPOINTMENTS_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    }

    case CANCEL_APPOINTMENT_SUCCESS: {
      return {
        ...state,
        result: state.result.filter(appointment => appointment.id !== action.payload.id),
      };
    }

    default:
      return state;
  }
};

const expressedInterests = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_EXPRESSED_INTERESTS_START: {
      return {
        ...state,
        loading: true,
      };
    }

    case FETCH_EXPRESSED_INTERESTS_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        result: action.payload.results,
        error: null,
      };
    }

    case FETCH_EXPRESSED_INTERESTS_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    }

    case UNEXPRESS_INTEREST_SUCCESS: {
      return {
        ...state,
        result: state.result.filter(expressedInterest => expressedInterest.id !== action.payload.id),
      };
    }

    default:
      return state;
  }
};

const expressedInterestsInstruments = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_EXPRESSED_INTERESTS_INSTRUMENTS_START: {
      return {
        ...state,
        loading: true,
      };
    }

    case FETCH_EXPRESSED_INTERESTS_INSTRUMENTS_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        result: action.payload,
        error: null,
      };
    }

    case FETCH_EXPRESSED_INTERESTS_INSTRUMENTS_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    }

    default:
      return state;
  }
};

const noMatchingTimeSlots = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_NO_MATCHING_TIMESLOTS_START: {
      return {
        ...state,
        loading: true,
      };
    }

    case FETCH_NO_MATCHING_TIMESLOTS_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        result: action.payload.results,
        error: null,
      };
    }

    case FETCH_NO_MATCHING_TIMESLOTS_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    }

    default:
      return state;
  }
};

const initialFormState = { submitting: false, error: null, result: {} };

const appointmentForm = (state = initialFormState, action) => {
  switch (action.type) {
    case MAKE_APPOINTMENT_START: {
      return {
        ...state,
        submitting: true,
      };
    }

    case MAKE_APPOINTMENT_SUCCESS: {
      return {
        ...state,
        submitting: false,
        result: action.payload,
        error: null,
      };
    }

    case MAKE_APPOINTMENT_ERROR: {
      return {
        ...state,
        submitting: false,
        error: action.payload,
      };
    }
    case MAKE_APPOINTMENT_RESET: {
      return { ...initialFormState };
    }

    default:
      return state;
  }
};

const updateAppointmentForm = (state = initialFormState, action) => {
  switch (action.type) {
    case UPDATE_APPOINTMENT_START: {
      return {
        ...state,
        submitting: true,
      };
    }

    case UPDATE_APPOINTMENT_SUCCESS: {
      return {
        ...state,
        submitting: false,
        result: action.payload,
        error: null,
      };
    }

    case UPDATE_APPOINTMENT_ERROR: {
      return {
        ...state,
        submitting: false,
        error: action.payload,
      };
    }
    case UPDATE_APPOINTMENT_RESET: {
      return { ...initialFormState };
    }

    default:
      return state;
  }
};

const expressInterestForm = (state = initialFormState, action) => {
  switch (action.type) {
    case EXPRESS_INTEREST_START: {
      return {
        ...state,
        submitting: true,
      };
    }

    case EXPRESS_INTEREST_SUCCESS: {
      return {
        ...state,
        submitting: false,
        result: action.payload,
        error: null,
      };
    }

    case EXPRESS_INTEREST_ERROR: {
      return {
        ...state,
        submitting: false,
        error: action.payload,
      };
    }
    case EXPRESS_INTEREST_RESET: {
      return { ...initialFormState };
    }

    default:
      return state;
  }
};

const noMatchingTimeSlotForm = (state = initialFormState, action) => {
  switch (action.type) {
    case NO_MATCHING_TIMESLOT_START: {
      return {
        ...state,
        submitting: true,
      };
    }

    case NO_MATCHING_TIMESLOT_SUCCESS: {
      return {
        ...state,
        submitting: false,
        result: action.payload,
        error: null,
      };
    }

    case NO_MATCHING_TIMESLOT_ERROR: {
      return {
        ...state,
        submitting: false,
        error: action.payload,
      };
    }

    case NO_MATCHING_TIMESLOT_RESET: {
      return { ...initialFormState };
    }

    default:
      return state;
  }
};

const initialCancelFormState = { submitting: false, error: null, result: false };

const cancelAppointmentForm = (state = initialCancelFormState, action) => {
  switch (action.type) {
    case CANCEL_APPOINTMENT_START: {
      return {
        ...state,
        submitting: true,
      };
    }

    case CANCEL_APPOINTMENT_SUCCESS: {
      return {
        ...state,
        submitting: false,
        result: true,
        error: null,
      };
    }

    case CANCEL_APPOINTMENT_ERROR: {
      return {
        ...state,
        submitting: false,
        error: action.payload,
      };
    }
    case CANCEL_APPOINTMENT_RESET: {
      return { ...initialCancelFormState };
    }

    default:
      return state;
  }
};

const unexpressInterestForm = (state = initialCancelFormState, action) => {
  switch (action.type) {
    case UNEXPRESS_INTEREST_START: {
      return {
        ...state,
        submitting: true,
      };
    }

    case UNEXPRESS_INTEREST_SUCCESS: {
      return {
        ...state,
        submitting: false,
        result: true,
        error: null,
      };
    }

    case UNEXPRESS_INTEREST_ERROR: {
      return {
        ...state,
        submitting: false,
        error: action.payload,
      };
    }
    case UNEXPRESS_INTEREST_RESET: {
      return { ...initialCancelFormState };
    }

    default:
      return state;
  }
};

const removeNoMatchingTimeSlotForm = (state = initialCancelFormState, action) => {
  switch (action.type) {
    case REMOVE_NO_MATCHING_TIMESLOT_START: {
      return {
        ...state,
        submitting: true,
      };
    }

    case REMOVE_NO_MATCHING_TIMESLOT_SUCCESS: {
      return {
        ...state,
        submitting: false,
        result: action.payload,
        error: null,
      };
    }

    case REMOVE_NO_MATCHING_TIMESLOT_ERROR: {
      return {
        ...state,
        submitting: false,
        error: action.payload,
      };
    }
    case REMOVE_NO_MATCHING_TIMESLOT_RESET: {
      return { ...initialCancelFormState };
    }

    default:
      return state;
  }
};

const scheduleCompletedForm = (state = initialFormState, action) => {
  switch (action.type) {
    case SCHEDULE_COMPLETE_START: {
      return {
        ...state,
        submitting: true,
      };
    }

    case SCHEDULE_COMPLETE_SUCCESS: {
      return {
        ...state,
        submitting: false,
        result: action.payload,
        error: null,
      };
    }

    case SCHEDULE_COMPLETE_ERROR: {
      return {
        ...state,
        submitting: false,
        error: action.payload,
      };
    }

    default:
      return state;
  }
};

export {
  schedulePrograms,
  appointments,
  studentAppointments,
  noMatchingTimeSlots,
  noMatchingTimeSlotForm,
  appointmentForm,
  cancelAppointmentForm,
  updateAppointmentForm,
  expressInterestForm,
  unexpressInterestForm,
  expressedInterests,
  sharedSchedules,
  scheduleCompletedForm,
  removeNoMatchingTimeSlotForm,
  expressedInterestsInstruments,
};
